import CustomSearchDropdown from "../../POP/FileComp5";
import _ from "lodash";
import { useSearchParams } from "react-router-dom";
import React, { useState, useEffect, useCallback } from "react";
import TableCompoenent from "../components/TableCompoenent";
import { FULL_API_BASE_URL } from "../../../Config/Config";
import { useDispatch, useSelector } from "react-redux";
import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
import DropDownCB from "../components/SingleDropdwon";
import FormInputs from "../DummyReportPage/FormInputs";
import dayjs from "dayjs";
import DropDownMultipleSelection from "../components/FieldsComponent";
import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
import WarnigImg from "./../../../Assets/Images/CommanImages/Warning.png";
import { useNavigate } from "react-router-dom";
const mapDataToDropdownFormat = (dataArray, idField, nameField) => {
  // Remove duplicates from the array
  return _.uniqBy(
    dataArray.map((item) => ({
      id: item[idField],
      label: item[nameField],
    })),
    "id"
  );
};

const ClassFeedback = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  pauseTimer,
  resumeTimer,
  dataClient,
  setPagePath,
}) => {
  const dispatch = useDispatch();
  const { coursesdata } = useSelector((state) => state.course);
  const [resultsData, setResultsData] = useState([]);
  // const [selectedStudentIds, setSelectedStudentIds] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [testnamedata, setTestNameData] = useState([]);
  const [isApplied, setIsApplied] = useState(false);
  const [resetKey, setResetKey] = useState(0);
  const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
  const [isVisible, setIsVisible] = useState(true); // For toggling sections visibility
  const [disabled, setDisabled] = useState(false); // For controlling dropdown disabling
  const [selectedBatchName, setSelectedBatchName] = useState("");
  const [testname, setTestName] = useState([]);
  const [chapterName, setChapterName] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const [filteredSubjects, setFilteredSubjects] = useState([]);
  const [filteredBatches, setFilteredBatches] = useState([]);
  const [apiData, setApiData] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [batchData, setBatchData] = useState([]);
  const [subjectData, setSubjectData] = useState([]);
  const [chapterData, setChapterData] = useState([]);
  const [dppData, setDppData] = useState([]);
  const [studentData, setStudentData] = useState([]);
  const [selectedCourseId, setSelectedCourseId] = useState("");
  const [selectedChapters, setSelectedChapters] = useState([]);
  const [selectedDppIds, setSelectedDppIds] = useState([]);
  const [selectedBatches, setSelectedBatches] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [searchColumn, setSearchColumn] = useState("");
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [feedbackData, setFeedbackData] = useState([]);
  const [value, setValues] = useState({
    report_title: "",
    course_id: "",
    batch_id: "",
    assessment_id: "",
    assessment_name: "",
    feedback_id: "",
    description: "",
    month: "",
    start_month: "",
    month: "Month to Date",
    end_month: "",
    subject_id: [], // Initialize as an empty array
    chapter_id: [], // Initialize as an empty array    month: "",
    start_month: "",
    end_month: "",
    subject_id: [],
    chapter_id: [],
  });

  const [searchParams] = useSearchParams();
  const reportName = searchParams.get("reportName");

  useEffect(() => {
    setPagePath("Reports > Reports Dashboard > Class Feedback by Student");
    if (selectedCourseId) {
      fetchDropdownData(); // Call only when selectedCourseId is updated and valid
    }
  }, [selectedCourseId]); // Trigger fetchDropdownData when selectedCourseId changes

  const fetchDropdownData = useCallback(async () => {
    try {
      if (!selectedCourseId) throw new Error("No course selected");

      const response = await fetch(
        `${FULL_API_BASE_URL}/get-dpp-report-filter-searchkey-v2/?course_id=${selectedCourseId}`,
        {
          method: "POST",
          headers: {
            accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            batch_ids: selectedBatches,
            subject_ids: selectedSubjects,
            chapter_ids: selectedChapters,
            assessment_ids: selectedDppIds,
            student_ids: selectedStudents,
            search_key: searchKey,
            search_column: searchColumn,
          }),
        }
      );
      const data = await response.json();
      // setBatchData(
      //   mapDataToDropdownFormat(data.batch_list, "batch_id", "batch_name")
      // );
      setSubjectData(
        mapDataToDropdownFormat(data.subject_list, "subject_id", "subject_name")
      );
      // Ensure unique chapters by chapter_id
      const uniqueChapters = _.uniqBy(data.chapter_list, "chapter_id");
      setChapterData(
        uniqueChapters.map((item) => ({
          id: item.chapter_id,
          chapter_name: item.chapter_name, // Field for Chapter Name
          subject_name: item.subject_name, // Field for Subject Name
          // batch_name: item.batch_name, // Field for Batch Name
        }))
      );

      setDppData(
        mapDataToDropdownFormat(
          data.assessment_list,
          "assessment_id",
          "assessment_name"
        )
      );
      const uniqueStudents = _.uniqBy(data.student_list, "student_id");
      setStudentData(
        uniqueStudents.map((item) => ({
          id: item.student_id,
          student_name: item.student_name, // Field for Student Name
          roll_number: item.roll_number, // Field for Roll Number
          batch_name: item.batch_name, // Field for Batch Name
        }))
      );
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }
  }, [
    selectedCourseId,
    selectedBatches,
    selectedSubjects,
    selectedChapters,
    selectedDppIds,
    selectedStudents,
    searchKey,
    searchColumn,
  ]);

  // Fetch batches based on selected course
  const fetchBatchesByCourse = async () => {
    try {
      const response = await fetch(
        `${FULL_API_BASE_URL}/get-batches-by-course/?course_id=${selectedCourseId}`
      );
      const data = await response.json();
      console.log(data, "batchData");

      setBatchData(
        data.map((batch) => ({
          id: batch.batch_id, // Map batch_id as id
          label: batch.batch_name, // Use batch_code as the label to display
        }))
      );
    } catch (error) {
      console.error("Error fetching batches:", error.message);
    }
  };

  // Trigger batch fetching when course is selected
  useEffect(() => {
    if (selectedCourseId) {
      fetchBatchesByCourse();
    }
  }, [selectedCourseId]);

  // Fetch feedbacks based on selected batch
  const fetchFeedbacksByBatch = async (batchId) => {
    try {
      const response = await fetch(
        `${FULL_API_BASE_URL}/get-feedbacks/?batch_id=${batchId}`
      );
      const data = await response.json();

      // Check if there is feedback data and map it, otherwise set feedbackData to an empty array
      if (data && data.data && data.data.length > 0) {
        setFeedbackData(
          data.data.map((feedback) => ({
            id: feedback.feedback_id, // Map feedback_id as id
            label: feedback.feedback_display_name, // Use feedback_display_name as the label
          }))
        );
      } else {
        setFeedbackData([]); // Clear the feedbackData if no feedback is returned
      }
    } catch (error) {
      console.error("Error fetching feedbacks:", error.message);
      setFeedbackData([]); // Clear feedbackData in case of an error
    }
  };

  // Trigger feedback fetching when batch is selected
  useEffect(() => {
    if (value.batch_id) {
      fetchFeedbacksByBatch(value.batch_id);
    }
  }, [value.batch_id]);

  const handleDropdownClose = () => {
    fetchDropdownData();
  };

  const handleSearchKeyChange = (key, dropdownType) => {
    if (
      key.length >= 3 &&
      (dropdownType === "student" || dropdownType === "chapter")
    ) {
      setSearchKey(key);
      setSearchColumn(dropdownType);
    } else {
      setSearchKey("");
      setSearchColumn("");
    }
  };

  useEffect(() => {
    dispatch(fetchCourseData());
  }, [dispatch]);

  const calculateDates = () => {
    const today = dayjs();
    let from_date = "";
    let end_date = today.format("YYYY-MM-DD HH:mm:ss");

    switch (value.month) {
      case "Last Month":
        from_date = today
          .subtract(1, "month")
          .startOf("month")
          .format("YYYY-MM-DD HH:mm:ss");
        end_date = today
          .subtract(1, "month")
          .endOf("month")
          .format("YYYY-MM-DD HH:mm:ss");
        break;
      case "Month to Date":
        from_date = today.startOf("month").format("YYYY-MM-DD HH:mm:ss");
        break;
      case "Week to Date":
        from_date = today.startOf("week").format("YYYY-MM-DD HH:mm:ss");
        break;
      case "Custom":
        const current_time = today.format("HH:mm:ss");
        from_date = `${value.start_month} 00:00:00`;
        end_date = `${value.end_month} ${current_time}`;
        break;
      default:
        break;
    }
    return { from_date, end_date };
  };

  const { from_date, end_date } = calculateDates();

  // const handleApplyOrReset = async () => {
  //   if (isApplied) {
  //     // Reset only non-essential fields while keeping the selected filters
  //     setResultsData([]); // Clear the table data
  //     setHeaders([]); // Clear the headers
  //     setIsApplied(false); // Set the state to not applied
  //     setIsColumnDivVisible(false); // Hide the column div if necessary
  //     setDisabled(false); // Enable dropdowns
  //     setResetKey((prevKey) => prevKey + 1); // Trigger key change to reset components

  //     // Retain the selected course, batch, chapter, subject, and date values
  //     setValues((prevValues) => ({
  //       ...prevValues,
  //       report_title: "",
  //       assessment_id: "",
  //       assessment_name: "",
  //       description: "",
  //       // Keep course, batch, chapter, subject, and date fields unchanged
  //       month: prevValues.month,
  //       start_month: prevValues.start_month,
  //       end_month: prevValues.end_month,
  //       course_id: prevValues.course_id,
  //       batch_id: prevValues.batch_id,
  //       subject_id: prevValues.subject_id,
  //       chapter_id: prevValues.chapter_id,
  //     }));
  //   } else {
  //     // Apply logic
  //     setIsApplied(true);
  //     setDisabled(true); // Disable dropdowns

  //     // Fetch the DPP Performance Data using selected filters
  //     const { from_date, end_date } = calculateDates(); // Use the calculateDates function to get date range

  //     if (!selectedCourseId) {
  //       setIsMessageBoxVisible(true);
  //       setMessageBox(
  //         <div
  //           className="Container-messageBOX"
  //           onMouseEnter={pauseTimer}
  //           onMouseLeave={resumeTimer}
  //         >
  //           <div className="messagebox-insider1">
  //             <div className="loader-tc"></div>
  //             <span>Please Select a Course</span>
  //           </div>
  //         </div>
  //       );
  //       setActiveImg(InterogativeImg);
  //       return;
  //     }

  //     const requestBody = {
  //       // course_id: selectedCourseId || null, // Selected course ID
  //       batch_ids: selectedBatches || [], // Selected batch IDs
  //       subject_ids: selectedSubjects || [], // Selected subject IDs
  //       chapter_ids: selectedChapters || [], // Selected chapter IDs
  //       // student_ids: selectedStudents.map(student => student.id) || [], // Selected student IDs
  //       student_ids: selectedStudents || [],
  //       // from_date: from_date, // Start date
  //       // end_date: end_date, // End date
  //     };

  //     try {
  //       // const response = await fetch(`${FULL_API_BASE_URL}/get-student-dpp-report-summary`, {
  //       const response = await fetch(
  //         `${FULL_API_BASE_URL}/get-subjectwise-dpp-performance?course_id=${selectedCourseId}&from_date=${encodeURIComponent(
  //           from_date
  //         )}&end_date=${encodeURIComponent(end_date)}`,
  //         {
  //           method: "POST",
  //           headers: {
  //             accept: "application/json",
  //             "Content-Type": "application/json",
  //           },
  //           body: JSON.stringify(requestBody), // Send selected values in the request body
  //         }
  //       );

  //       const data = await response.json();
  //       if (data && data.length > 1) {
  //         setHeaders(data[0]); // Set headers
  //         setResultsData(data.slice(1)); // Set results
  //       } else {
  //         setResultsData([]);
  //         setIsMessageBoxVisible(true);
  //         setMessageBox(
  //           <div
  //             className="Container-messageBOX"
  //             onMouseEnter={pauseTimer}
  //             onMouseLeave={resumeTimer}
  //           >
  //             <div className="messagebox-insider1">
  //               <div className="loader-tc"></div>
  //               <span>No data found for the selected date range.</span>
  //             </div>
  //           </div>
  //         );
  //         setActiveImg(WarnigImg);
  //       }
  //     } catch (error) {
  //       setResultsData([]);
  //       setIsMessageBoxVisible(true);
  //       setMessageBox(
  //         <div
  //           className="Container-messageBOX"
  //           onMouseEnter={pauseTimer}
  //           onMouseLeave={resumeTimer}
  //         >
  //           <div className="messagebox-insider1">
  //             <div className="loader-tc"></div>
  //             <span>{error.message}</span>
  //           </div>
  //         </div>
  //       );
  //       setActiveImg(InterogativeImg);
  //     }
  //   }
  // };

  const handleApplyOrReset = async () => {
    if (isApplied) {
      // Reset only non-essential fields while keeping the selected filters
      setResultsData([]); // Clear the table data
      setHeaders([]); // Clear the headers
      setIsApplied(false); // Set the state to not applied
      setIsColumnDivVisible(false); // Hide the column div if necessary
      setDisabled(false); // Enable dropdowns
      setResetKey((prevKey) => prevKey + 1); // Trigger key change to reset components

      // Retain the selected course, batch, chapter, subject, and date values
      setValues((prevValues) => ({
        ...prevValues,
        report_title: "",
        // assessment_id: "",
        // assessment_name: "",
        // description: "",
        // Keep course, batch, chapter, subject, and date fields unchanged
        // month: prevValues.month,
        // start_month: prevValues.start_month,
        // end_month: prevValues.end_month,
        course_id: prevValues.course_id,
        batch_id: prevValues.batch_id,
        // subject_id: prevValues.subject_id,
        // chapter_id: prevValues.chapter_id,
        feedback_id: prevValues.feedback_id,
      }));
    } else {
      // Apply logic
      setIsApplied(true);
      setDisabled(true); // Disable dropdowns

      // Get feedback_id from selected values
      const selectedFeedbackId = value.feedback_id;

      if (!selectedFeedbackId) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div
            className="Container-messageBOX"
            onMouseEnter={pauseTimer}
            onMouseLeave={resumeTimer}
          >
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>Please Select a Feedback</span>
            </div>
          </div>
        );
        setActiveImg(InterogativeImg);
        return;
      }

      try {
        // Fetch feedback details by feedback ID
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-feedbacks-by-id/?feedback_id=${selectedFeedbackId}`,
          {
            method: "GET",
            headers: {
              accept: "application/json",
            },
          }
        );

        const data = await response.json();

        if (data && data.data && data.data.length > 1) {
          setHeaders(data.data[0]); // Set headers (from the first row)
          setResultsData(data.data.slice(1)); // Set results (remaining rows)
        } else {
          setResultsData([]); // No data
          setIsMessageBoxVisible(true);
          setMessageBox(
            <div
              className="Container-messageBOX"
              onMouseEnter={pauseTimer}
              onMouseLeave={resumeTimer}
            >
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>No data found for the selected feedback.</span>
              </div>
            </div>
          );
          setActiveImg(WarnigImg);
        }
      } catch (error) {
        setResultsData([]); // Clear results
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div
            className="Container-messageBOX"
            onMouseEnter={pauseTimer}
            onMouseLeave={resumeTimer}
          >
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>{error.message}</span>
            </div>
          </div>
        );
        setActiveImg(InterogativeImg);
      }
    }
  };

  const dropdownStyle = isApplied
    ? { opacity: 0.5, pointerEvents: "none" }
    : { opacity: 1, pointerEvents: "auto" };
  const navigate = useNavigate();

  // GET COURSE WHEN WE PRINT
  const course =
    coursesdata && coursesdata.length > 0
      ? coursesdata.find((course) => course.course_id === selectedCourseId)
          ?.course_description || ""
      : "";

  const selectedBatch =
    batchData && batchData.length > 0
      ? batchData.find((batch) => batch.id === value.batch_id)?.label || ""
      : "";

  // const getSelectedSubjectNames = () => {
  //   if (selectedSubjects.length === 0) return 'All';
  //   const subjectNames = subjectData
  //     .filter((subject) => selectedSubjects.includes(subject.id))
  //     .map((subject) => subject.label);
  //   return subjectNames.join(', ');
  // };

  const selectedFeedback =
    feedbackData && feedbackData.length > 0
      ? feedbackData.find((feedback) => feedback.id === value.feedback_id)
          ?.label || ""
      : "";

  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "36.5px",
        marginBottom: "40px",
      }}
    >
      <div style={{ position: "sticky", top: "0" }}>
        <div className="Header-up">
          <span
            style={{
              color: "#2F2E40",
              fontSize: "30px",
              textTransform: "capitalize",
            }}
          >
            {reportName}
          </span>
          <div
            className="testreportcard-header-btn-container"
            style={{ marginRight: "30px" }}
          >
            <button
              className="testreportcard-cancel-btn"
              // onClick={handleCancel}
              onClick={() => {
                navigate("/report_management");
              }}
            >
              CANCEL
            </button>

            <button
              className="testreportcard-create-btn"
              onClick={handleApplyOrReset}
            >
              {isApplied ? "RESET" : "APPLY"}
            </button>
          </div>
        </div>
      </div>
      <div style={{ display: isVisible ? "block" : "none", marginTop: "1vh" }}>
        <div className="row-cs-uni">
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`course_${resetKey}`}
          >
            <DropDownCB
              label="Course"
              style={{ width: "13.5vw" }}
              selected={selectedCourseId}
              setSelected={setSelectedCourseId}
              options={
                coursesdata
                  ? coursesdata.map((course) => ({
                      id: course.course_id,
                      label: course.course_description,
                    }))
                  : []
              }
            />
          </div>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`batch_${resetKey}`}
          >
            <DropDownCB
              label="Batch"
              style={{ width: "13.5vw" }}
              selected={value.batch_id}
              setSelected={(selectedBatch) =>
                setValues({ ...value, batch_id: selectedBatch })
              }
              options={batchData}
            />
          </div>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`feedback_${resetKey}`}
          >
            <DropDownCB
              label="Feedback"
              style={{ width: "13.5vw" }}
              selected={value.feedback_id}
              setSelected={(selectedFeedback) =>
                setValues({ ...value, feedback_id: selectedFeedback })
              }
              options={feedbackData}
            />
          </div>
        </div>
        {/* <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`subject_${resetKey}`}
          >
            <DropDownMultipleSelection
              width="13.5vw"
              label="Select Subject"
              selected={selectedSubjects}
              setSelected={setSelectedSubjects}
              options={subjectData}
              customWidth="100%"
              isRequired={false}
              showSelectAll={true}
              onDropdownClose={handleDropdownClose}
            />
          </div>
        </div> */}
        {/* <div
          className="grid-container-radio-button"
          style={{ marginTop: "1vh", height: "35px", ...dropdownStyle }}
        >
          <div className="item5">
            <div className="toggle-radio">
              <input
                type="radio"
                id="last month"
                name="month"
                value="Last Month"
                checked={value.month === "Last Month"}
                onChange={(e) => setValues({ ...value, month: e.target.value })}
                disabled={isApplied}
              />
              <label htmlFor="last month">Previous Month</label>
            </div>
          </div>
          <div className="item6">
            <div className="toggle-radio">
              <input
                type="radio"
                id="month to date"
                name="month"
                value="Month to Date"
                checked={value.month === "Month to Date"} // Ensures "Month to Date" is selected by default
                onChange={(e) => setValues({ ...value, month: e.target.value })}
                disabled={isApplied}
              />
              <label htmlFor="month to date">Month to Date</label>
            </div>
          </div>
          <div className="item7">
            <div className="toggle-radio">
              <input
                type="radio"
                id="week to date"
                name="month"
                value="Week to Date"
                checked={value.month === "Week to Date"}
                onChange={(e) => setValues({ ...value, month: e.target.value })}
                disabled={isApplied}
              />
              <label htmlFor="week to date">Week to Date</label>
            </div>
          </div>
          <div className="item8">
            <div className="toggle-radio">
              <input
                type="radio"
                id="custom"
                name="month"
                value="Custom"
                checked={value.month === "Custom"}
                onChange={(e) => setValues({ ...value, month: e.target.value })}
                disabled={isApplied}
              />
              <label htmlFor="custom">Custom</label>
            </div>
          </div>
          {value.month === "Custom" && (
            <>
              <div className="item9">
                <FormInputs
                  type="date"
                  name="start_month"
                  value={value.start_month}
                  onChange={(e) =>
                    setValues({ ...value, start_month: e.target.value })
                  }
                  disabled={isApplied}
                />
              </div>
              <div className="item10">To</div>
              <div className="item11">
                <FormInputs
                  type="date"
                  name="end_month"
                  value={value.end_month}
                  onChange={(e) =>
                    setValues({ ...value, end_month: e.target.value })
                  }
                  disabled={isApplied}
                />
              </div>
            </>
          )}
        </div> */}
      </div>
      <div style={{ position: "relative", marginTop: "20px" }}>
        <button
          style={{
            position: "absolute",
            top: "-1px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 1,
            width: "60px",
            height: "10px",
            backgroundColor: "white",
            border: "none",
          }}
          onClick={() => {
            setIsExpanded(!isExpanded);
            setIsVisible(!isVisible);
          }}
        >
          <p style={{ fontSize: "20px", color: "black" }}>...</p>
        </button>
        <TableCompoenent
          headers={headers.map((header) => header.substring(2))}
          data={resultsData}
          searchPlaceholder="Search by Student Name..."
          isColumnDivVisible={isColumnDivVisible}
          setIsColumnDivVisible={setIsColumnDivVisible}
          dataClient={dataClient}
          ReportPageHeader={reportName}
          course={course}
          batch={selectedBatch}
          feedback={selectedFeedback}
          dppName={""}
          isExpanded={isExpanded} // Pass the new isExpanded prop
        />
      </div>
    </div>
  );
};

export default ClassFeedback;
